import { useState, useEffect, useCallback } from "react";
import "../styles/HomePage.css";

import HeroBanner from "../components/HeroBanner";
import CategorySlider from "../components/CategorySlide";
import WhatNewDontMissOut from "../components/WhatNewDontMissOut";
import CleanLivingStart from "../components/CleanLivingStart";
import CarpetObsession from "../components/CarpetObsession";
import ShopbyCategory from "../components/ShopbyCategory";
import ShopbyDesign from "../components/ShopbyDesign";
import BathEssentials from "../components/BathEssentials";
import FindYourFloors from "../components/FindYourFloors";
import ObsessionsinAction from "../components/ObsessionsinAction";
import Footer from "../../../components/Footer/Footer";
// import OfferModelbox from "../components/OfferModelbox";
import ProductQuickViewModal from "../../Products/quickView/pages/ProductsQuickViewModal";

const HomePage = () => {
  const [showModal, setShowModal] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState(null);

  // Page load par scroll reset
  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo({ top: 0 });
  }, []);

  // Quick View Handler (Memoized)
  const handleQuickView = useCallback((product) => {
    if (!product) return;

    const cleanProduct = {
      ...product,
      action_url: String(product.action_url || "")
        .replace(/^\/+/, "")
        .replace(/\/+$/, ""),
    };

    setQuickViewProduct(cleanProduct);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  }, []);

  // Modal Close Handler (Memoized)
  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    document.body.style.overflow = "auto";
  }, []);

  return (
    <>
      <HeroBanner />
      <CategorySlider />
      <WhatNewDontMissOut />
      {/* Quick View Components */}
      <CleanLivingStart onQuickView={handleQuickView} />
      <CarpetObsession onQuickView={handleQuickView} />
      <FindYourFloors />
      <ShopbyCategory />
      <ShopbyDesign />
      <BathEssentials onQuickView={handleQuickView} />
      <ObsessionsinAction />
      {/* Quick View Modal */}
      <ProductQuickViewModal
        show={showModal}
        onHide={handleCloseModal}
        product={quickViewProduct}
      />
      <Footer />
      {/* <OfferModelbox /> */}
    </>
  );
};

export default HomePage;